// extracted by mini-css-extract-plugin
export default {"container":"DocumentsTabListItemControls_container__98ssD"};